import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { walletEndpoints } from "@/features/wallet/api/endpoints";
import type { WalletBalanceDto } from "@/features/wallet/api/dto";

/**
 * Soldes d'un portefeuille (`GET /Wallets/{id}/balance`) — montants `*Minor`
 * en unité mineure (§4.3), formatage via `AmountMinor` (features/shared).
 */
export const useWalletBalance = (walletId: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.WALLET_BALANCE(walletId),
    queryFn: () =>
      fetchDataGet<WalletBalanceDto>({
        url: walletEndpoints.wallets.balance(walletId),
      }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(walletId),
  });
